import 'react-app-polyfill/stable';
import 'core-js/stable/regexp';

import 'intersection-observer';
// to support smooth scroll for Safari 15.3 and under
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
